import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Typography,
} from "@mui/material";
import { useState, ReactNode } from "react";

type Props = {
    children?: ReactNode;
    title: string;
};

export default function New_Item({ children, title }: Props) {
    const [open, set_open] = useState(false);

    function handle_open() {
        set_open((curr) => !curr);
    }

    return (
        <Box m={2} mb={0}>
            <Accordion expanded={open} onChange={handle_open}>
                <AccordionSummary>
                    <Typography variant="h5">{title}</Typography>
                </AccordionSummary>

                <AccordionDetails
                    key={`${title.replaceAll(" ", "").toLowerCase()}-${open}`}
                >
                    {children}
                </AccordionDetails>
            </Accordion>
        </Box>
    );
}
